import React, { useState, lazy, Suspense } from 'react';
import cn from 'classnames';
import CloseButton from 'components/UI/CloseButton';
import LazyImage from 'components/UI/LazyImage';
import { useStateModal } from 'utils/hooks';
import { pushCustomEvent } from 'utils/analytics';

import * as styles from './OfficePopup.module.scss';

const GalleryModal = lazy(() => import('components/Modals/GalleryModal'));

const IMAGES_TO_SHOW_COUNT = 3;

function OfficePopup({ closeHandler, title, category, address, phone, images = [], className }) {
  const isWideCard = images.length > 2 || images.length === 0;
  const [clickedImageIndex, setClickedImageIndex] = useState();
  const { modalState, showModal, hideModal } = useStateModal();

  const handleClickedImageIndex = i => {
    setClickedImageIndex(i);
    showModal();
    pushCustomEvent('ndrsn_about_us_block', {
      action: 'click_on_image',
      label: `image ${i + 1}`,
    });
  };

  const imagesToShow = images.slice(0, IMAGES_TO_SHOW_COUNT);
  const hiddenImagesCount =
    images.length > IMAGES_TO_SHOW_COUNT ? images.length - IMAGES_TO_SHOW_COUNT : null;

  const style = { '--hideImagesCount': hiddenImagesCount };

  return (
    <section className={cn(styles.wrapper, className, isWideCard && styles.wide)}>
      {closeHandler && (
        <CloseButton className={styles.closeButton} onClose={closeHandler} theme="dark" size="sm" />
      )}
      <div className={styles.content}>
        <p className={styles.title}>{title}</p>
        <div className={styles.category}>
          <LazyImage
            className={styles.categoryIcon}
            src={category.icon}
            alt={category.name}
            aria-hidden={true}
          />
          <span>{category.name}</span>
        </div>
        <address className={styles.address}>{address}</address>
        {phone && (
          <a href={`tel:${phone}`} className={styles.phone}>
            {phone}
          </a>
        )}
        {imagesToShow?.length > 0 && (
          <div className={styles.gallery}>
            {imagesToShow.map(({ url }, i) => (
              <div
                key={`img-${i}`}
                className={cn(styles.imgWrapper, hiddenImagesCount && styles.hideImagesCount)}
                style={style}
                role="button"
                onClick={() => handleClickedImageIndex(i)}
              >
                <LazyImage className={styles.img} src={url} />
              </div>
            ))}
          </div>
        )}
      </div>
      {modalState.isOpen && (
        <Suspense fallback={null}>
          <GalleryModal
            title={title}
            isOpen={modalState.isOpen}
            images={images}
            closeModalCallback={hideModal}
            initialImageIndex={clickedImageIndex}
          />
        </Suspense>
      )}
    </section>
  );
}

export default OfficePopup;
